import { toast as base } from 'sonner';

// Studio toasts appear at the bottom so they never cover the top bar's
// Save / Download buttons (shorter on phones, where they overlap the tools).
const withDefaults = (options = {}) => {
  const phone = window.matchMedia('(max-width: 1023px)').matches;
  return { position: 'bottom-center', ...(phone ? { duration: 2500 } : {}), ...options };
};

export const toast = {
  success: (message, options) => base.success(message, withDefaults(options)),
  error: (message, options) => base.error(message, withDefaults(options)),
  info: (message, options) => base.info(message, withDefaults(options)),
  loading: (message, options) => base.loading(message, withDefaults({ duration: Infinity, ...options })),
  dismiss: (id) => base.dismiss(id),
};

export default toast;
